var map = {
	"./camera-normal.png": "2cf8",
	"./none.png": "02c0",
	"./rain-0.png": "c9c8",
	"./rain-1.png": "1797",
	"./rain-2.png": "52aa",
	"./rain-3.png": "fb51",
	"./rain-4.png": "1cd4",
	"./rain-default.png": "660e",
	"./rain-deficit.png": "fc12",
	"./raintank-normal.png": "56e4",
	"./raintank-normal.svg": "9efa",
	"./soil-deficit.png": "a450",
	"./soil-normal.png": "b1d9",
	"./stage-dangerous.png": "3f11",
	"./stage-default.png": "aa90",
	"./stage-deficit.png": "0373",
	"./stage-evacuation.png": "5d5f",
	"./stage-normal.png": "0d40",
	"./stage-outbreak.png": "98b5",
	"./stage-standby.png": "e39e",
	"./stage-start.png": "67c9",
	"./stage-warning.png": "3083"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "89b8";